import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "./SimplePresentationRunner";
import {FlightMode} from "../FlightMode";
import {gsap} from "gsap";

export class SetStartingMultiplier implements SimplePresentation {

    shouldRun(): boolean {
        return FlightMode.model.isFirstSpin() &&
               FlightMode.model.hasStartingMultipliers() &&
               FlightMode.model.startingMultiplier() > 1;
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline();

        tl.add(() => {
            controller.setSkipCallback(() => {tl.progress(1, false)})
        })

        if (FlightMode.reelView.getCurrentMultiplier() != FlightMode.model.startingMultiplier())
            tl.add(FlightMode.reelView.updateMultiplierCounter(FlightMode.model.startingMultiplier() - 1));

        tl.add(() => {
            controller.finish();
        });
    }
}